var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tabbed-grid-dropdown',{attrs:{"label":_vm.label,"options":_vm._options,"group-all":_vm.groupAll,"multiple":_vm.multiple,"allText":"All","clearable":"","select-all":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }